module.exports = __webpack_public_path__ + "img/1f3b8.fb57863.svg";